"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPicToWordFlashcardOrWordToPicFlashcardBackType = exports.isFlashcardOrFlashcardBackType = exports.isAnyFlashcardType = exports.AnyFlashcardTypeSchema = exports.getFlashcardTypeIdFromName = exports.flashcardTypeIdToTypeNameMap = void 0;
const zod_1 = require("zod");
const type_validation_helpers_1 = require("../../helpers/type_validation_helpers");
const flashcard_back_type_types_1 = require("./flashcard_back_type_types");
const premade_flashcard_type_types_1 = require("./premade_flashcard_type_types");
const sentence_flashcard_type_types_1 = require("./sentence_flashcard_type_types");
const word_flashcard_type_types_1 = require("./word_flashcard_type_types");
// INTENDED because sort-keys-fix is stupid and doesn't realize that we are
// sorting by numbers
/* eslint-disable sort-keys-fix/sort-keys-fix */
exports.flashcardTypeIdToTypeNameMap = Object.freeze({
    1: "PIC_TO_WORD",
    2: "FILL_IN_THE_BLANK",
    3: "FILL_IN_THE_BLANK_ROOT",
    4: "WORD_ORDER",
    7: "WORD_TO_ANY",
    8: "MINIMAL_PAIR",
    9: "ALPHABET",
    10: "SPELLING",
    11: "WORD_STRESS",
    12: "PRONOUNCE",
    13: "MISSING_LETTER",
    14: "STROKE_ORDER",
    15: "TONE",
    16: "UGC_FILL_IN_THE_BLANK",
    17: "UGC_WORD_TO_SENTENCE",
    18: "UGC_WORD_ORDER",
});
/* eslint-enable sort-keys-fix/sort-keys-fix */
const getFlashcardTypeIdFromName = (type) => {
    const keys = Object.keys(exports.flashcardTypeIdToTypeNameMap);
    return parseInt(keys.find((key) => exports.flashcardTypeIdToTypeNameMap[key] === type), 10);
};
exports.getFlashcardTypeIdFromName = getFlashcardTypeIdFromName;
exports.AnyFlashcardTypeSchema = zod_1.z.union([
    premade_flashcard_type_types_1.AnyPremadeFlashcardTypeSchema,
    sentence_flashcard_type_types_1.AnySentenceFlashcardTypeSchema,
    word_flashcard_type_types_1.AnyWordFlashcardTypeSchema,
]);
exports.isAnyFlashcardType = type_validation_helpers_1.getTypeValidationFunction(exports.AnyFlashcardTypeSchema);
const AnyFlashcardOrFlashcardBackTypeSchema = zod_1.z.union([
    exports.AnyFlashcardTypeSchema,
    flashcard_back_type_types_1.AnyFlashcardBackTypeSchema,
]);
exports.isFlashcardOrFlashcardBackType = type_validation_helpers_1.getTypeValidationFunction(AnyFlashcardOrFlashcardBackTypeSchema);
const PicToWordFlashcardOrWordToPicFlashcardBackTypeSchema = zod_1.z.union([
    word_flashcard_type_types_1.PicToWordFlashcardTypeSchema,
    flashcard_back_type_types_1.WordToPicFlashcardBackTypeSchema,
]);
exports.isPicToWordFlashcardOrWordToPicFlashcardBackType = type_validation_helpers_1.getTypeValidationFunction(PicToWordFlashcardOrWordToPicFlashcardBackTypeSchema);
//# sourceMappingURL=flashcard_type_types.js.map